import React, { useState } from 'react'
import poster from "../../assests/no_poster.png"
import { FaGreaterThan } from "react-icons/fa6";
// import google from "../../assests/google.png"
import { toast } from 'react-toastify';
import { updateCampaignAssociateStatus } from '../../services/ApiService';
import { ConfirmModal } from '../ConfirmModal';
import { getFlatformImg, getPlatformImg } from '../../helpers/getImgSrc';
import { useNavigate } from 'react-router-dom';

const CampaignSocialMediaCard = ({internalCampaign,externalCampaign,fetchSocialMediaMetrics}) => {
   const [disassociating,setDisassociating]=useState(false)
   const [disassociateConfirmModal,setDisassociateConfirmModal]=useState(false)
   const navigate=useNavigate()

    const disassociateCampaing= async(externalCampaign)=>{
        setDisassociating(true)
        let formData = new FormData();
        try {
            formData.append("campaign_id", parseInt(internalCampaign?.campaign_id));
            formData.append("platform_id", externalCampaign?.platform_id);
           formData.append("external_campaign_id", externalCampaign?.campaign_id)
          formData.append("is_mapped", externalCampaign?.is_mapped);
            const response = await updateCampaignAssociateStatus(formData)
            if(response?.success){
                toast.success(response?.message||"Campaign Disassociated Successfully");
                fetchSocialMediaMetrics()
            }else{
                toast.error(response?.error?.error_message||"Something went wrong");
            }
        } catch (error) {
            toast.error("Something went wrong");
        }finally{
            setDisassociating(false)
        }
  
    }

  return (
    <div className="row px-1 py-3 campaign_item_card">
    <div className="col-lg-2 col-md-3 position-relative">
        <div className="campaign_item_card_poster position-relative" >

            <img src={ poster} className="" alt="" />
            <div className="position-absolute bg-primary">

            </div>
        </div>


    </div>
    <div className="col-lg-10 col-md-9">
        <div
            className="d-flex flex-wrap justify-content-between  my-2 pb-2  border-bottom ">
            <div className="d-flex align-items-center gap-2 ">
                 <img src={getPlatformImg(externalCampaign?.platform_id)} className="img-fluid social_media_img" alt="" />
               
                <p className="mb-0 text_color_secondary">{externalCampaign?.campaign_name?externalCampaign?.campaign_name:''} Post</p>
            </div>
            <span>{externalCampaign?.platform?externalCampaign?.platform:''} Platform</span>

        </div>
        <div className="row d-flex align-items-center mt-2">
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0">$ {externalCampaign?.metrics?.total_spent?externalCampaign?.metrics?.total_spent:'0'}</p>
                    <span className="campaign_sub_card_badge rounded-pill badge_1 ">+00%</span>
                </div>
                <span>Total Spent</span>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0">{externalCampaign?.metrics?.impressions||'0'}</p>
                    <span
                        className="campaign_sub_card_badge rounded-pill badge_2">+00%</span>
                </div>
                <span>Impressions</span>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0">{externalCampaign?.metrics?.clicks||'0'}</p>
                    <span
                        className="campaign_sub_card_badge rounded-pill badge_2">+00%</span>
                </div>
                <span>Clicks</span>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0"> {externalCampaign?.metrics?.click_through_rate||'0'}</p>
                    <span
                        className="campaign_sub_card_badge rounded-pill badge_1">+00%</span>
                </div>
                <span>CTR</span>
                
            </div>
                  <div className="col-4 d-flex gap-4 justify-content-end">
                      <button disabled={disassociating} onClick={() => {setDisassociateConfirmModal(true)}} 
                      className="btn  btn-primary btn-sm rounded-pill">{disassociating?"Please wait...":"Disassociate"}</button>

                      <button onClick={() => {
                       navigate(`${externalCampaign?.campaign_id}/${externalCampaign?.platform_id}`)
                      }} className="btn  btn-primary btn-sm rounded-pill">View More <FaGreaterThan /></button>
                  </div>
              </div>

    </div>

    <ConfirmModal 
        show={disassociateConfirmModal} 
        onClose={()=>setDisassociateConfirmModal(false)} 
        title={"Disassociate Ad"} 
        body={"Are you sure you want to disassociate this Ad ? You can re-associate it later from the Link Campaigns section."} 
        closeBtnTitle={"Cancel"} 
        submitBtnTitle={"Continue"} 
        onSubmit={()=>disassociateCampaing(externalCampaign)} 
        loadingOnsubmit={disassociating}
    />

</div>
  )
}

export default CampaignSocialMediaCard